import Input from "@material-ui/core/Input";
import PropTypes from "prop-types";
import React from "react";
import {withStyles} from "@material-ui/core/styles";



const styles = {
	numericInput: {
		textAlign: 'right',
		width: '100%',
		'&::-webkit-input-placeholder' :{
			textAlign: 'left'
		},
		'&:-moz-placeholder' : {
			textAlign: 'left'
		},
		'&::-moz-placeholder' : {
			textAlign: 'left'
		},
		'&:-ms-input-placeholder' : {
			textAlign: 'left'
		}

	},
};
const NumberEditorBase = ({ value, onValueChange, classes }) => {
	const handleChange = (event) => {
		const { value: targetValue } = event.target;
		if (targetValue.trim() === '') {
			onValueChange();
			return;
		}
		onValueChange(parseInt(targetValue, 10));
	};
	return (
		<Input
			type="number"
			classes={{
				input: classes.numericInput,
			}}
			fullWidth
			value={value === undefined ? '' : value}
			inputProps={{
				min: 0,
				placeholder: '絞り込み',
			}}
			onChange={handleChange}
		/>
	);
};

NumberEditorBase.propTypes = {
	value: PropTypes.number,
	onValueChange: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

NumberEditorBase.defaultProps = {
	value: undefined,
};
export default withStyles(styles)(NumberEditorBase);



// WEBPACK FOOTER //
// ./src/common/components/table/components/filter-number-editor.js